<div class="ui grid">
  <div class="row">
    <div class="column">
      <h1 class="ui header" i18n="@@author-edit-article">Artikel bearbeiten:</h1>
      <app-article-form [topics]="topics" [subjectAreas]="subjectAreas" [institutions]="institutions"
                        #articleFormComponent></app-article-form>
    </div>
  </div>
  <div class="row">
    <div class="column">

      @if (article?.isDraft) {
        <button
          type="submit"
          class="ui yellow button"
          [disabled]="articleFormComponent.articleForm.controls.title.invalid"
          (click)="saveArticle()"
          i18n="@@save-draft"
        >
          Entwurf speichern
        </button>
        <button
          type="submit"
          class="ui primary button"
          [disabled]="!articleFormComponent.articleForm.valid"
          (click)="saveArticle(true)"
          i18n="@@save-and-publish"
        >
          Speichern und veröffentlichen
        </button>
      } @else {
        <button
          type="submit"
          class="ui primary button"
          [disabled]="!articleFormComponent.articleForm.valid"
          (click)="saveArticle()"
          i18n="@@save"
        >
          Speichern
        </button>
      }
    </div>
  </div>

  @if (article?.changelog?.length) {
    <div>
      <div class="ui header" i18n="@@article-changelog">Änderungshistorie:</div>
      @for (change of article?.changelog; track change) {
        <details>
          <summary>
            {{ change.timestamp | date:'medium' }}
            •
            <ng-container i18n="@@article-changes">
              {{ change.diff.length }} {change.diff.length, plural, =1 {Änderung} other {Änderungen}}
            </ng-container>
            •
            {{ change.name }} ({{ change.email }})
          </summary>
          @for (diff of change.diff; track diff) {
            <app-changelog [diff]="diff"></app-changelog>
          }
        </details>
      }
    </div>
  }

  <div class="row">
    <div class="column">
      <div i18n="@@author-necessary">* erforderlich</div>
      <div i18n="@@author-necessary-not-permanent">** erforderlich, außer bei dauerhafter Ausschreibung</div>
    </div>
  </div>
</div>
